import { Col, Image, Row } from 'react-bootstrap';
import { formatMoneyShorthand } from 'utils/formatMoney';
import { useDrag } from 'react-dnd';
import DefaultAvatar from 'components/global/DefaultAvatar';
import FounderPiplineItemContextMenu from 'components/views/FounderPipeline/_components/FounderPiplineItemContextMenu';
import { $view } from 'signals/global.signals';

const FounderPipelineListItem = ({ pipelineItem }) => {
  // Access the signal value to create a subscription
  const { isDragDisabled } = $view.value;

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'investor',
    item: { pipelineItem },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [pipelineItem]);

  // Add defensive check after hooks to prevent hook inconsistencies
  if (!pipelineItem) {
    return null;
  }

  return (
    <div
      ref={isDragDisabled ? null : drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        cursor: isDragDisabled ? 'default' : 'move',
      }}
      className="position-relative bg-gray-800 border border-gray-700 rounded px-32"
    >
      <Row className="align-items-center pb-16">
        <Col className="d-flex align-items-center" sm={1}>
          <div
            className="d-flex justify-content-center rounded-circle flex-shrink-0 profileSettingsAvatar mb-md-0 my-16"
            style={{ width: '40px', height: '40px' }}
          >
            {pipelineItem?.organization?.logoImage
              ? <Image src={pipelineItem?.organization?.logoImage} style={{ objectFit: 'cover' }} />
              : (
                <DefaultAvatar
                  name={pipelineItem?.organization?.name}
                  image={pipelineItem?.organization?.logoImage}
                  size="md"
                />
              )}
          </div>
        </Col>
        <Col sm={3}>
          <div><small className="text-gray-400">Organization</small></div>
          {pipelineItem.organization?.name}
        </Col>
        <Col sm={3}>
          <div><small className="text-gray-400">Deal Name</small></div>
          {pipelineItem?.deal?.name}
        </Col>
        <Col>
          <div><small className="text-gray-400">Invested</small></div>
          {formatMoneyShorthand(pipelineItem?.amountInvested)}
        </Col>
        <Col>
          <div><small className="text-gray-400">Committed</small></div>
          {formatMoneyShorthand(pipelineItem?.previouslyCommitted)}
        </Col>
        <Col>
          <div><small className="text-gray-400">Deal ID</small></div>
          {pipelineItem?.dealId}
        </Col>
        <Col className="d-flex justify-content-end mt-16">
          <FounderPiplineItemContextMenu pipelineItem={pipelineItem} />
        </Col>
      </Row>
    </div>
  );
};

export default FounderPipelineListItem;
